import { aboutPoints } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <span className="text-xs md:text-sm font-semibold uppercase tracking-widest text-accent-600">
              Platform Overview
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              这是一个怎样的页面
            </h2>
            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700">
              「中文在线字幕免费高清」是一个围绕在线字幕与视频观看需求的信息聚合主题。很多用户在寻找
              <strong className="font-semibold text-foreground-900">官网入口</strong>时，会同时遇到地址变动、
              仿冒站点、下载来源不明等问题。本页把这些问题集中说明，让你一次看懂该去哪里找、怎么判断。
            </p>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              需要说明的是，本页并不托管任何视频内容，也不代表官方运营。它更像一份「使用前的说明手册」：
              先帮你建立判断标准，再带你把入口、地址、下载三件事逐一确认清楚。
            </p>

            <div className="mt-8 overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20minimal%20flat%20illustration%20of%20a%20desk%20setup%20with%20laptop%20tablet%20and%20phone%20showing%20subtitle%20caption%20bars%2C%20cream%20amber%20and%20soft%20sage%20color%20palette%2C%20clean%20geometric%20shapes%2C%20editorial%20style%2C%20soft%20paper%20texture%2C%20calm%20harmonious%20composition&width=900&height=560&seq=subtitle-about-02&orientation=landscape"
                alt="电脑、平板与手机多端字幕使用场景示意插画"
                className="h-48 md:h-64 w-full object-cover object-top"
              />
            </div>
          </div>

          <div className="grid gap-4 md:gap-5">
            {aboutPoints.map((p) => (
              <article
                key={p.title}
                className="rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-6"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${p.icon} text-xl`}></i>
                </div>
                <h3 className="mt-4 font-heading text-lg md:text-xl font-bold text-foreground-950">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm md:text-base leading-relaxed text-foreground-700">
                  {p.desc}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}